import { openDialog, dialogModel } from "../../common/dialog";

const props = {
    adminVoucherEditMarker:'.marker-voucher-management-edit',
    deleteVoucherButton: '#mdc-button--delete-voucher'
};

export function initAdminVoucherEdit() {
    if ($(props.adminVoucherEditMarker).length) {
        bindDeleteVoucher();
    }
}


function bindDeleteVoucher(){
    $(props.deleteVoucherButton).click(function (e) {
        e.preventDefault();
        const voucherId = $('#Id').val();

        openDialog({
            ...dialogModel,
            title: 'Delete Voucher',
            content: 'Are you sure you want to delete this voucher?',
            confirmButtonText: 'Delete',
            onConfirm: () => deleteVoucher(voucherId),
            theme: 'delete'
        });
    });
}

function deleteVoucher(voucherId) {
    window.location.replace('/administration/vouchermanagement/deletevoucher/' + voucherId);
}